export const propertyUnitLabels = {
   density: {
      SI: '(g/cm³)',
      US: '(g/cm³)'
   },
   flowRate: {
      SI: '(g/10 min)',
      US: '(g/10 min)'
   },
   notchedImpactIso: {
      SI: '(kJ/m²)',
      US: '(ft-lb/in²)'
   },
   notchedImpactAstm: {
      SI: '(J/m)',
      US: '(ft-lb/in)'
   }
};
